import { useField } from "formik";
import { CalculatorFormControl } from "shared/ui/components/CalculatorFormControl";

const CalculatorFormikField = ({
  withControl = true,
  name,
  hidden = false,
  component: Component,
  controlProps,
  componentProps,
}: any) => {
  const [field, meta, helpers] = useField(
    componentProps?.type === "checkbox" || componentProps?.type === "radio"
      ? {
        name,
        type: componentProps.type,
        value: componentProps.value,
      }
      : name
  );

  const { touched, error } = meta;

  const haveError = touched && !!error;

  if (hidden) {
    return null;
  }

  if (!withControl) {
    return (
      <Component
        haveError={haveError}
        name={name}
        error={error}
        field={field}
        helpers={helpers}
        {...componentProps}
      />
    );
  }

  return (
    <CalculatorFormControl
      haveError={haveError}
      error={error}
      {...controlProps}
    >
      <Component
        haveError={haveError}
        name={name}
        field={field}
        helpers={helpers}
        {...componentProps}
      />
    </CalculatorFormControl>
  );
};

export default CalculatorFormikField;
